import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Danish CPR generator following Single Responsibility Principle
 */
export class CprGenerator extends BaseGenerator {
  generate(options = {}) {
    const { formatted = true, birthDate = null } = options;

    let ddmmyy;
    if (birthDate) {
      const date = new Date(birthDate);
      const day = this.padZero(date.getDate(), 2);
      const month = this.padZero(date.getMonth() + 1, 2);
      const year = date.getFullYear().toString().slice(-2);
      ddmmyy = day + month + year;
    } else {
      const day = this.padZero(this.randomInt(1, 28), 2);
      const month = this.padZero(this.randomInt(1, 12), 2);
      const year = this.padZero(this.randomInt(0, 99), 2);
      ddmmyy = day + month + year;
    }

    // Generate sequence number and check digit
    let cpr;
    let attempts = 0;
    do {
      const sequence = this.randomDigits(3);
      const checkDigit = this.randomInt(0, 9);
      cpr = ddmmyy + sequence + checkDigit;
      
      // Validate checksum
      const weights = [4, 3, 2, 7, 6, 5, 4, 3, 2, 1];
      let sum = 0;
      for (let i = 0; i < 10; i++) {
        sum += parseInt(cpr[i]) * weights[i];
      }
      
      attempts++;
    } while (sum % 11 !== 0 && attempts < 100);

    return formatted ? 
      `${cpr.substring(0, 6)}-${cpr.substring(6, 10)}` : 
      cpr;
  }
}